import { Container, Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import ClientEditSidebar, {
    ACTIVE_CLIENT_SIDEBAR_TAB_NAMES
} from '../clientedit/ClientEditSidebar';
import ActivityImportPage from './components/ActivityImportPage';

const ActivityImportPageWrapper = () => {
    const { clientId } = useParams();

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <ClientEditSidebar activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.activityimport} />
                <Grid className="pageContent">
                    <ActivityImportPage companyId={parseInt(clientId, 10)} />
                </Grid>
            </Grid>
        </Container>
    );
};

export default ActivityImportPageWrapper;
